// extracted by mini-css-extract-plugin
export default {"btop":"_3f93159769 _91b40124ca fcbaa4ae34","icon":"e1e4d6be16 _27d55ea6a4","btoppink":"aeafc73bba _6dbc3574e7"};